import { IOfferDescriptionRewardParameter } from "./IOfferDescriptionRewardParameter";

import { IPrivateOfferModel } from "../../offerQuestConditions/IPrivateOfferModel";

export class BasicOfferRewardFactory {
    protected modelData: IPrivateOfferModel;

    constructor(model: IPrivateOfferModel) {
        this.modelData = model;
    }

    public createOfferRewardObject(name: string, params: any): IOfferDescriptionRewardParameter {
        return null;
    }

    public dispose(): void {
        this.modelData = null;
    }
}

